<template>
  <div style="position: relative">
    <v-text-field
      :model-value="busqueda"
      color="indigo"
      variant="outlined"
      density="comfortable"
      :loading="cargando"
      clearable
      label="Escribe el nombre o RUT"
      autocomplete="off"
      @update:model-value="onEscribir"
      @click:clear="onLimpiar"
      @focus="mostrarResultados = !!busqueda"
      @keydown.esc="mostrarResultados = false"
    ></v-text-field>

    <v-card
      v-if="mostrarResultados"
      variant="outlined"
      rounded="lg"
      elevation="4"
      style="position: absolute; top: 100%; left: 0; right: 0; z-index: 50; max-height: 320px; overflow-y: auto"
    >
      <v-list v-if="miembros.length" density="comfortable">
        <v-list-item
          v-for="item in miembros"
          :key="item.id"
          :subtitle="'RUT: ' + item.telefono"
          @click="seleccionar(item)"
        >
          <template v-slot:prepend>
            <v-avatar color="indigo-lighten-4" size="40">
              <v-img v-if="item.imagen" :src="urlImagen(item.imagen)" cover></v-img>
              <v-icon v-else color="indigo">mdi-account</v-icon>
            </v-avatar>
          </template>
          <v-list-item-title>{{ item.nombre }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <div v-else-if="cargando" class="px-4 py-3 text-body-2 text-muted">
        Buscando...
      </div>
      <div v-else class="px-4 py-3 text-body-2 text-muted">
        No se encontraron resultados con {{ busqueda }}
      </div>
    </v-card>
  </div>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";

export default {
  name: "BusquedaMiembro",

  data: () => ({
    cargando: false,
    busqueda: "",
    miembros: [],
    miembroSeleccionado: null,
    mostrarResultados: false,
  }),

  mounted() {
    document.addEventListener("click", this.onClickFuera);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.onClickFuera);
  },

  methods: {
    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    onClickFuera(evento) {
      if (this.$el && !this.$el.contains(evento.target)) {
        this.mostrarResultados = false;
      }
    },

    onEscribir(texto) {
      this.busqueda = texto || "";
      this.mostrarResultados = !!texto;
      this.buscarMiembros(texto);
    },

    onLimpiar() {
      this.busqueda = "";
      this.miembros = [];
      this.mostrarResultados = false;
    },

    seleccionar(item) {
      this.miembros = [];
      this.mostrarResultados = false;
      this.busqueda = item.nombre;
      this.miembroSeleccionado = item;
    },

    buscarMiembros(texto) {
      if (texto) {
        this.busqueda = texto;
        let payload = {
          metodo: "obtener_nombre_matricula",
          busqueda: this.busqueda,
        };
        this.cargando = true;
        HttpService.obtenerConDatos(payload, "miembros.php").then(
          (resultados) => {
            this.miembros = resultados;
            this.cargando = false;
          }
        );
      } else {
        this.miembros = [];
      }
    },
  },

  watch: {
    miembroSeleccionado(miembro) {
      this.$emit("seleccionado", miembro);
    },
  },
};
</script>
